import { useQuery } from "@tanstack/react-query";
import { useState } from "react"
import { getHistoricoPicagens } from "../../services/api.service";
import { DateDisplayer } from "../../charts/components/filters/DatesFilter/DateDisplayer";
import { DatePicker } from "@mui/x-date-pickers";
import { TextField } from "@mui/material";




export function MonitorizacaoPicagens() {

    const [data, setData] = useState(new Date());

    const { data: historicoPicagens } = useQuery({
        queryKey: [data],
        queryFn: async () => await getHistoricoPicagens(data.toISOString().split('T')[0])
    })



    return (
        <div className="p-6">
            <h1 className="text-2xl mb-5">Histórico de picagens</h1>
            <hr className="border-[1.5px] rounded mb-5" />
            <div>

                <DateDisplayer>
                    <h2 className="font-bold mb-10">Data atual {data.toISOString().split('T')[0]}</h2>
                    <DatePicker
                        value={data}
                        views={['year', 'month', 'day']}
                        onChange={(value: Date | null) => setData(value || new Date(Date.now()))}
                        renderInput={(params) => <TextField {...params} />}
                    />

                </DateDisplayer>
            </div>
            {historicoPicagens ? <div >
                <div className="grid grid-cols-4 gap-4 font-bold mb-3">
                    <div className="col-span-2">Nome</div>
                    <div>Entradas</div>
                    <div>Saídas</div>
                </div>
                <hr />
                {Object.entries(historicoPicagens).map(([k, v]: any, idx: number) => <>
                    <div className={`grid grid-cols-4 gap-4 p-2 ${idx % 2 === 0 ? 'bg-zinc-200' : ''}`}>
                        <div className="col-span-2">{k}</div>
                        <div>
                            <div>{v['Entrada']?.map((vv : string) => (<div>
                                {vv?.split('T')[1]?.split('.')[0]}
                            </div>))}</div>
                        </div>
                        <div>
                        <div>{v['Saida']?.map((vv : string) => (<div>
                                {vv?.split('T')[1]?.split('.')[0]}
                            </div>))}</div>
                            
                        </div>
                    </div>
                    <hr />
                </>)}
            </div> : null}
        </div>
    )




}